import gql from "graphql-tag";

export const allManagersQuery = gql`
  query allManagers($inactive: InactiveFilter = without) {
    allManagers(inactive: $inactive) {
      id
      name
    }
  }
`;
